import './DocumentDeliverySectionRow.scss';

import React from 'react';
import PropTypes from 'prop-types';

import DocumentDeliveryRowLabel from 'components/layouts/Preferences/DocumentDelivery/DocumentDeliveryRowLabel';
import Radio from 'components/shared/Radio/Radio';

const DocumentDeliverySectionRow = ({
  disableMailSelection = false, // explicitly set to false if undefined so that radio button 'checked' property is always true/false
  disableEMailSelection = false,
  isEmailDelivery = false, // see above comment
  serviceTypeId,
  title,
  modalContent,
  updateDeliverySelection,
  hasInvalidOrMissingEmail
}) => (
  <div className="document-delivery-section-content-row">
    <div className="document-delivery-radio-label">
      <DocumentDeliveryRowLabel
        label={title}
        modalContent={modalContent}
        serviceTypeId={serviceTypeId}
      />
    </div>
    <div className="document-delivery-radio-buttons">
      {disableEMailSelection ? (
        <Radio
          checked={isEmailDelivery || disableMailSelection}
          className="radio-button-disabled-mail"
          dataTestId={`email-radio-id-${serviceTypeId}`}
          name={serviceTypeId}
          disabled={true}
        />
      ) : (
        <Radio
          checked={isEmailDelivery || disableMailSelection}
          className="radio-button-email"
          dataTestId={`email-radio-id-${serviceTypeId}`}
          name={serviceTypeId}
          onChange={() => updateDeliverySelection(serviceTypeId, true)}
          disabled={hasInvalidOrMissingEmail}
        />
      )}

      {disableMailSelection || hasInvalidOrMissingEmail ? (
        <Radio
          checked={!isEmailDelivery}
          disabled={true}
          className="radio-button-disabled-mail"
          name={serviceTypeId}
        />
      ) : (
        <Radio
          checked={!isEmailDelivery}
          className="radio-button-mail"
          dataTestId={`mail-radio-id-${serviceTypeId}`}
          name={serviceTypeId}
          onChange={() => updateDeliverySelection(serviceTypeId, false)}
        />
      )}
    </div>
  </div>
);

DocumentDeliverySectionRow.propTypes = {
  disableMailSelection: PropTypes.bool,
  isEmailDelivery: PropTypes.bool,
  serviceTypeId: PropTypes.number,
  title: PropTypes.string,
  modalContent: PropTypes.string,
  updateDeliverySelection: PropTypes.func,
  hasInvalidOrMissingEmail: PropTypes.bool
};

export default DocumentDeliverySectionRow;
